import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { PartFinderReelResults } from 'partFinder/components';
import { canAccessPartFinder } from 'partFinder/utils';

export const PartFinderReelResultsPage = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const { user, isLoading } = useAuthUser();

  const title = t('titlePartFinderCatalog');

  if (isLoading) {
    return <PageLayout title={title} />;
  }

  if (!canAccessPartFinder(user)) {
    return (
      <PageLayout title={title}>
        <Error statusCode={StatusCode.ACCESS_DENIED} />
      </PageLayout>
    );
  }

  return (
    <PageLayout title={title}>
      <PartFinderReelResults familyId={Number(id)} />
    </PageLayout>
  );
};
